import { fetchApi } from '@/config/axiosSetting';
import {
  InitialVisitVehicleInfoQueryParamsType,
  InitialVisitVehicleInfoQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/InitialVisitVehicleInfo/InitialVisitVehicleInfoQuery.type';

export const InitialVisitVehicleInfoFunction = (
  params: InitialVisitVehicleInfoQueryParamsType,
): Promise<InitialVisitVehicleInfoQueryResponseType> => {
  return fetchApi.get(
    `/initial/reports/${params.id}/adjusting/vehicle_information/`,
    { params },
  );
};
